import React from 'react'

function PromocodeUserComponent({ data }) {
    return (
        <div className="form-group col-md-12  text-left">
            {/* <label>Eligible Users</label> */}
            <div className="row">
                {data.alloed_users.length > 0 && data.alloed_users.map((user, index) => {
                    return (
                        <div className="col-xl-3" >
                            <div className="card">
                                <div className="card-body" >
                                    <a href={`/customerID/${user.id}`}>
                                        <span className="card-text" style={{ fontSize: "16px" }}>{"FDRCSR" + user.id} </span><br />
                                        <span className="card-text" style={{ fontSize: "14px" }}>{" "}{user.first_name} </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    )
                })
                }
            </div>
        </div>
    )
}

export default PromocodeUserComponent
